
<div class="content">
    <div class="item">           
        <app-site-rating [rating]="4" [useBlueIcons]="true" class="site-rating"></app-site-rating>                     
        <div class="site-rating-desc"><span class="item-desc">Bacterial levels are safe for swimming according to National Health and Medical Research Council guidelines (<41cfu/100mL)</span></div>
    </div>

    <div class="item">
        <app-site-rating [rating]="3" [useBlueIcons]="true" class="site-rating"></app-site-rating>            
        <div class="site-rating-desc"><span class="item-desc">Bacterial levels indicate an increased risk of illness to swimmers, particularly those with lower immune function such as the elderly and young children (41-200cfu/100mL)</span></div>
    </div>        

    <div class="item">
        <app-site-rating [rating]="2" [useBlueIcons]="true" class="site-rating"></app-site-rating>            
        <div class="site-rating-desc"><span class="item-desc">Bacterial levels indicate an increased risk of illness to swimmers (201-500cfu/100mL)</span></div>
    </div>

    <div class="item">
        <app-site-rating [rating]="1" [useBlueIcons]="true" class="site-rating"></app-site-rating>            
        <div class="site-rating-desc"><span class="item-desc">Bacterial levels indicate a substantially increased risk of illness to swimmers (>500cfu/100mL)</span></div>
    </div>
    
</div>
  

